import { useEffect, useState } from "react";
import axios from "axios";
import { API, fmtErr } from "../lib/pos";

export default function ResetPassword() {
  // Capture the token exactly ONCE at mount, then scrub it from the URL. Using a
  // useState initializer means subsequent re-renders (setPassword, setBusy, setErr…)
  // keep the token in memory even after `window.location.search` is emptied.
  const [token] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return p.get("token") || "";
  });
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");
  const year = new Date().getFullYear();

  // Wipe the token out of the visible URL after mount so browser history / referrer
  // don't leak it if the user forwards a screenshot.
  useEffect(() => {
    if (token) {
      try { window.history.replaceState({}, "", "/reset-password"); } catch (_) { /* ignore */ }
    }
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return setErr("This reset link is invalid or has expired.");
    if (password.length < 8) return setErr("Password must be at least 8 characters.");
    if (password !== confirm) return setErr("Passwords do not match.");
    setBusy(true); setErr("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setOk(true);
      setTimeout(() => { window.location.href = "/"; }, 1600);
    } catch (ex) { setErr(fmtErr(ex)); }
    finally { setBusy(false); }
  };

  return (
    <div className="auth-page" data-testid="reset-password-page">
      <div className="auth-card">
        <div className="auth-brand">
          <img src="/logo.jpg" alt="Shimla QoH Food Court" className="auth-logo" />
          <div>Shimla QoH<small>FOOD COURT · POS</small></div>
        </div>
        <p className="eyebrow" style={{ marginTop: 22 }}>RESET PASSWORD</p>
        <h1>Choose a new password</h1>
        <p className="muted" style={{ marginTop: 6 }}>
          Pick something you'll remember — at least 8 characters. You'll need to sign in with the new password.
        </p>
        {ok ? (
          <div className="auth-success" data-testid="reset-success">
            Password updated. Redirecting to sign in…
          </div>
        ) : (
          <form onSubmit={submit} className="auth-form" autoComplete="off">
            <label>New password
              <input
                data-testid="reset-password-input"
                type="password"
                name={`newpw_${Math.random().toString(36).slice(2, 8)}`}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                maxLength={128}
                required
              />
            </label>
            <label>Confirm password
              <input
                data-testid="reset-password-confirm-input"
                type="password"
                name={`confirm_${Math.random().toString(36).slice(2, 8)}`}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                maxLength={128}
                required
              />
            </label>
            {err && <div data-testid="reset-error" className="auth-error">{err}</div>}
            <button
              data-testid="reset-submit-button"
              className="primary wide"
              disabled={busy}
              type="submit"
            >{busy ? "Saving…" : "Set new password"}</button>
          </form>
        )}
      </div>
      <div className="app-copyright" data-testid="copyright-footer">
        Copyright {year}: KKK Food Court Pvt Ltd
      </div>
    </div>
  );
}
